import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { colorPalette } from '~/themes/colors/colorPalette'
import { textStyleKeys } from '~/themes/textStyles'
import { CallTranscript } from '~/types/CallTranscript'

import { SectionHeader } from './SectionHeader'

interface InterruptionsSectionProps {
  transcript: CallTranscript
}

const InturruptionsSectionRow = ({
  title,
  count,
  highlight,
}: {
  title: string
  count: number
  highlight?: boolean
}) => {
  const font = highlight ? textStyleKeys.Body2_Bold : textStyleKeys.Body3

  return (
    <Flex
      flexDirection="row"
      backgroundColor={
        highlight ? colorPalette.gray[400] : colorPalette.achromatic.transparent
      }
      justifyContent="flex-start"
      borderRadius="0.75rem"
      paddingLeft="0.75rem"
      paddingRight="0.75rem"
    >
      <Text textStyle={font} width="50%">
        {title}
      </Text>
      <Text textStyle={font}>{count}</Text>
    </Flex>
  )
}

export const InterruptionsSection = ({
  transcript,
}: InterruptionsSectionProps) => {
  const totalInterruptions =
    transcript.ConversationCharacteristics.Interruptions.TotalCount

  const agentInterruptions =
    transcript.ConversationCharacteristics.Interruptions
      .InterruptionsByInterrupter.AGENT?.length ?? 0

  const customerInterruptions =
    transcript.ConversationCharacteristics.Interruptions
      .InterruptionsByInterrupter.CUSTOMER?.length ?? 0

  return (
    <Flex
      flexDirection="column"
      width="100%"
      gap="0.875rem"
      flex="1 0 100%"
      height="7.125rem"
    >
      <SectionHeader
        title="Interruptions"
        tooltipText="This shows a breakdown of how many times the patient and office interrupted each other. It's useful for evaluating how smoothly the conversation went."
      />
      <Flex
        flexDirection="column"
        justifyContent="center"
        flex="1 0 0"
        gap="0.5rem"
      >
        <InturruptionsSectionRow
          title="Total"
          count={totalInterruptions}
          highlight
        />
        <InturruptionsSectionRow
          title="Patient"
          count={customerInterruptions}
        />
        <InturruptionsSectionRow title="Office" count={agentInterruptions} />
      </Flex>
    </Flex>
  )
}
